import { Action } from "antd-mobile/es/components/action-sheet"
import { useSetMealTypeParams } from "features/meal/hooks"
import { LogMealType } from "model/food/types/base.types"
import DropdownDownIcon from "components/Icons/DropdownDownIcon"
import { MealTypePopover, MealTypeValue, MealTypeValueBox } from "./styled"
import { useState } from "react"
import CustomDropdown from "components/inputs/CustomDropdown"
import { capitalizeFirstLetter } from "utils/formater"
import { IDropdownItem } from "components/inputs/CustomDropdown/types"

export const logMealTypeOptions: IDropdownItem[] = [
  { value: "breakfast", label: "Breakfast" },
  { value: "lunch", label: "Lunch" },
  { value: "dinner", label: "Dinner" },
  { value: "snack", label: "Snack" },
]

const PageTitleMealTypeSelection = () => {
  const { mealTypeValue, setMealType } = useSetMealTypeParams()
  const [isPopoverVisible, setIsPopoverVisible] = useState(false)

  const displayMealType = mealTypeValue
    ? capitalizeFirstLetter(mealTypeValue.toLowerCase())
    : "Meal type"

  return (
    <CustomDropdown
      value={mealTypeValue?.toLowerCase()}
      groupItems={[logMealTypeOptions]}
      onChange={(nextValue) => {
        setMealType(nextValue?.toUpperCase())
      }}
      onVisibleChange={setIsPopoverVisible}
    >
      <MealTypeValueBox $isActive={isPopoverVisible}>
        <MealTypeValue $hasValue={!!mealTypeValue}>
          {displayMealType}
        </MealTypeValue>
        <DropdownDownIcon />
      </MealTypeValueBox>
    </CustomDropdown>
  )
}

export default PageTitleMealTypeSelection
